import { cloneDeep } from 'lodash';

const state = {
  list: [],
  review: {},
  edit_review: {}
};

const getters = {
  list: (state) => {
    return state.list || {};
  },
  review: (state) => {
    return state.review || {};
  },
  edit_review: (state) => {
    return state.edit_review || {};
  }
};

const mutations = {
  SET_LIST(state, items) {
    state.list = items;
  },
  SET_REVIEW(state, review) {
    state.review = cloneDeep(review);
    state.edit_review = cloneDeep(review);
    const index = state.list.findIndex((x) => x.id === review.id);
    if (index < 0) {
      state.list.push(cloneDeep(review));
    } else {
      this._vm.$set(state.list, index, review);
    }
  },
  EDIT_REVIEW(state, item) {
    state.edit_review = item;
  }
};

const actions = {
  load({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('reviews/getList')
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  set({ commit }, item) {
    commit('SET_REVIEW', item);
  },
  edit({ commit }, item) {
    commit('EDIT_REVIEW', item);
  },
  update({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('reviews/update', req)
        .then((response) => {
          commit('SET_REVIEW', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
